import { useEffect, useState } from 'react'

/**
 * Delays unmounting content when a visibility flag transitions to false,
 * allowing CSS transitions to complete before removing DOM elements.
 *
 * Returns true immediately when `isOpen` becomes true, but delays returning
 * false by `delay` ms when `isOpen` becomes false.
 */
export function useDelayedUnmount(isOpen: boolean, delay: number): boolean {
	const [shouldRender, setShouldRender] = useState(isOpen)

	useEffect(() => {
		if (isOpen) {
			setShouldRender(true)
		} else {
			const timer = setTimeout(() => setShouldRender(false), delay)
			return () => clearTimeout(timer)
		}
	}, [isOpen, delay])

	return shouldRender
}
